<script>
  import { onMount } from "svelte";
  import { Router, Link, Route } from "svelte-routing";

  import Home from "./views/Home.svelte";
  import NotFound from "./views/NotFound.svelte";
  import Loading from "./views/Loading.svelte";
  import Demo from "./views/Demo.svelte";
  import Terms from "./views/Terms.svelte";
  import VideoDemo from "./views/VideoDemo.svelte";
  import Sherlock from "./models/Sherlock.js";

  import CommonDataManager from "./controllers/CommonDataManager.js";
  const commonData = CommonDataManager.getInstance();
  let sherlock = Sherlock.getInstance();

  export let url = "";
  let initialViewPath = window.location?.pathname + (window.location?.search ? window.location?.search : "");

  onMount(async () => {
    commonData.setLandingLoadedHandler(onLandingLoaded);
  });

  let isLoaded = false;
  function onLandingLoaded() {
    isLoaded = true;
  }

  const views = [
    { component: NotFound, path: "*" },
    { component: Terms, path: "/" },
    // { component: Demo, path: "/demo" },
    // { component: VideoDemo, path: "/video-demo" },
    // { component: Terms, path: "/terms" },
  ];

  setTimeout(() => {
    document.addEventListener(
      "visibilitychange",
      () => {
        console.log("Visibility change");
        if (document.visibilityState === "hidden") {
          sherlock.appOnBackground();
        } else {
          sherlock.appOnScreen();
        }
      },
      false
    );
  }, 2000);
</script>

{#if isLoaded}
  <Router {url}>
    <div class="web_wrapper">
      <div class="active_view_wrapper">
        <div class="active_view">
          {#each views as view}
            <Route path={view.path} let:params>
              <svelte:component this={view.component} {...params} />
            </Route>
          {/each}
        </div>
      </div>
    </div>
  </Router>
{:else}
  <Loading />
{/if}

<style>
  .web_wrapper {
    display: flex;
    flex-direction: row;
    width: 100vw;
  }
  .active_view_wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .active_view {
    flex: 1;
    overflow-x: hidden;
  }
</style>
